interface UserFullnameProps {
  fullname: string;
  isDeleted?: boolean;
  className?: string;
}

export function UserFullname({ fullname, isDeleted, className }: UserFullnameProps) {
  if (isDeleted) {
    return (
      <span className={`line-through text-muted-foreground ${className ?? ''}`.trim()}>
        {fullname}
      </span>
    );
  }

  return <span className={className}>{fullname}</span>;
}
